/* =================================
  CORANO WISHLIST – FINAL SAFE FIX
================================= */

var WISHLIST_KEY = 'shopify-wishlist';
var ACTIVE_CLASS = 'active';

var SELECTORS = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  empty: '.wishlist-grid--empty-list'
};

/* ---------- Storage ---------- */

function getWishlist() {
  var data = localStorage.getItem(WISHLIST_KEY);
  return data ? data.split(',').filter(Boolean) : [];
}

function setWishlist(list) {
  list.length
    ? localStorage.setItem(WISHLIST_KEY, list.join(','))
    : localStorage.removeItem(WISHLIST_KEY);
}

function toggleWishlist(handle) {
  var list = getWishlist();
  var i = list.indexOf(handle);
  i === -1 ? list.push(handle) : list.splice(i, 1);
  setWishlist(list);
}

/* ---------- Buttons ---------- */

function setupButtons(scope) {
  (scope || document).querySelectorAll(SELECTORS.button).forEach(function (btn) {
    var handle = btn.dataset.productHandle;
    if (!handle) return;

    if (getWishlist().includes(handle)) {
      btn.classList.add(ACTIVE_CLASS);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleWishlist(handle);
      btn.classList.toggle(ACTIVE_CLASS);
      document.dispatchEvent(new Event('wishlist:update'));
    });
  });
}

/* ---------- Grid ---------- */

function setupGrid() {
  var grid = document.querySelector(SELECTORS.grid);
  var empty = document.querySelector(SELECTORS.empty);
  if (!grid) return;

  var wishlist = getWishlist();
  grid.innerHTML = '';

  if (!wishlist.length) {
    if (empty) empty.style.display = 'block';
    return;
  }

  if (empty) empty.style.display = 'none';

  wishlist.forEach(function (handle) {
    fetch('/products/' + handle + '.js')
      .then(r => r.json())
      .then(function (product) {
        fetch('/products/' + handle + '?view=card')
          .then(r => r.text())
          .then(function (html) {
            grid.insertAdjacentHTML('beforeend', html);
            setupButtons(grid);
          });
      });
  });
}

/* ---------- Init ---------- */

document.addEventListener('DOMContentLoaded', function () {
  setupButtons();
  setupGrid();
});

document.addEventListener('wishlist:update', setupGrid);
